<script>
  export default {
    mounted() {
      this.$root.botaoAcaoMostrar = true;
    }
  }
</script>

<template>
  <router-view :key="$route.path"></router-view>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-faturamento-estrangeiro-pf/componentes/SolicitacaoFaturamento.vue